import {
    type AdminAgentArtifact,
    ArtifactEvidence,
    ArtifactFrame,
    ArtifactLifecycleStatusBadge,
} from '@apps/web/routes/_app/admin/agent/artifacts/frame';
import {
    type AdminArtifactRendererProps,
    isRecord,
    renderUntrustedString,
    toRecord,
} from '@apps/web/routes/_app/admin/agent/artifacts/shared';

export function AdminRegistryFixtureArtifact({
    artifact,
}: AdminArtifactRendererProps) {
    const rows = getPayloadRows(artifact.payload);
    return (
        <ArtifactFrame
            artifact={artifact}
            status={
                <ArtifactLifecycleStatusBadge
                    lifecycleStatus={artifact.lifecycle_status}
                />
            }
        >
            <ArtifactEvidence artifact={artifact} />
            {rows.length > 0 ? (
                <table className="w-full text-left text-xs">
                    <tbody>
                        {rows.map((row, index) => (
                            <tr
                                key={`${index}-${row.label}`}
                                className="border-border/40 border-t align-top first:border-t-0"
                            >
                                <td className="text-foreground py-1.5 pr-3 font-medium">
                                    {renderUntrustedString(row.label)}
                                </td>
                                <td className="text-muted-foreground py-1.5">
                                    {renderUntrustedString(row.detail)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : null}
        </ArtifactFrame>
    );
}

function getPayloadRows(
    payload: AdminAgentArtifact['payload'],
): ReadonlyArray<{ readonly label: string; readonly detail: string }> {
    const rows = toRecord(payload)['rows'];
    if (!Array.isArray(rows)) {
        return [];
    }
    return rows.filter(isRecord).flatMap((row) => {
        if (
            typeof row['label'] !== 'string' ||
            typeof row['detail'] !== 'string'
        ) {
            return [];
        }
        return [{ label: row['label'], detail: row['detail'] }];
    });
}
